import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import FormikFormFileInput from '../../../shared-components/FormikFormHandlers/FormikFormFileInput';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import { formatMessage } from '../../../translations/format-message';

interface IProps extends IAddEditFormProps<any> {
  duplicateData: string;
}

const ImportActiveTrayDetailsForm = (props: IProps) => {
  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validateOnBlur={false}
        onSubmit={async (values) => {
          props.submitHandler(values);
        }}
      >
        {({ setFieldValue }) => {
          return (
            <Form className="user-form">
              {props.isLoading ? (
                <FormLoader loading={props.isLoading} contained />
              ) : null}
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style  col-form-label"
                        required={true}
                        label="file"
                      />
                      <Field
                        data-testid="csvFile"
                        className="form-control"
                        name="csvFile"
                        value={undefined}
                        invalidcharacter={[' ']}
                        validcharacter={['@', '#', '$', '-', '_', '.']}
                        placeholder=""
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        as={FormikFormFileInput}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          if (
                            event.target.files != null &&
                            event.target.files.length > 0
                          ) {
                            setFieldValue('csvFile', event.target.files[0]);
                          }
                        }}
                      />
                    </div>
                  </div>
                  {props.duplicateData.length > 0 && (
                    <div className="duplicated-data">
                      {formatMessage('records_already_exist')}
                      {props.duplicateData}
                    </div>
                  )}
                </div>
              </Modal.Body>
              <ModalFooter
                id={props.id}
                onModalClosed={props.onModalClosed}
                isLoading={props.isLoading}
                saveNextBtn={'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default ImportActiveTrayDetailsForm;
